/*=========================================================================================
  File Name: moduleEmailActions.js
  Description: Email Module Actions
  ----------------------------------------------------------------------------------------

==========================================================================================*/

import emailService from '../../services/email.service'


const data = {
  emails: [],
  // emailTags: [
  //   {
  //     text: 'Personal',
  //     value: 'personal',
  //     color: 'success'
  //   },
  //   {
  //     text: 'Company',
  //     value: 'company',
  //     color: 'primary'
  //   },
  //   {
  //     text: 'Important',
  //     value: 'important',
  //     color: 'warning'
  //   },
  //   {
  //     text: 'Private',
  //     value: 'private',
  //     color: 'danger'
  //   }
  // ]
}

export default {
  setEmailSearchQuery({ commit }, query) {
    commit('SET_EMAIL_SEARCH_QUERY', query)
  },

  // Fetch emails
  // fetchEmails({ commit }, payload) {
  //   return new Promise((resolve, reject) => {
  //     const filter = payload.filter

  //     let filteredEmails = data.emails.filter((email) => {

  //       if (filter == 'all_mail') return email.mailFolder !== 'trash';
  //       if (filter == 'inbox') return email.mailFolder === 'inbox'
  //       if (filter === 'sent_mail') return email.mailFolder === 'sent_mail'
  //       if (filter === 'drafts') return email.mailFolder === 'drafts'
  //       if (filter === 'starred') return email.isStarred && email.mailFolder !== 'trash'
  //       if (filter === 'trash') return email.mailFolder === 'trash'
  //       if (filter === 'spam') return email.mailFolder === 'spam'
  //       else return email.mailFolder != 'trash' && email.labels.includes(filter)

  //     }).reverse()
  //     commit('SET_MAILS', filteredEmails)
  //     resolve({ data: filteredEmails })
  //   })
  // },

  // Fetch Tags
  // fetchTags({ commit }) {
  //   return new Promise((resolve, reject) => {
  //     commit('SET_TAGS', data.emailTags)
  //     resolve({ data: data.emailTag })
  //   })
  // },

  // Fetch Email Meta
  // fetchMeta({ commit }) {
  //   return new Promise((resolve, reject) => {
  //     const countUnreadMailFolders = ['inbox', 'spam']

  //     const meta = {
  //       unreadMails: {
  //         folder: {},
  //         label: {}
  //       },
  //       draftMails: []
  //     }

  //     data.emails.forEach((mail) => {

  //       // Count unread mails
  //       if (mail.unread) {

  //         // Add mail id
  //         if (countUnreadMailFolders.includes(mail.mailFolder)) {
  //           meta.unreadMails.folder[mail.mailFolder] ? meta.unreadMails.folder[mail.mailFolder].push(mail.id) : meta.unreadMails.folder[mail.mailFolder] = [mail.id]
  //         }

  //         // Add mail id
  //         mail.labels.forEach((label) => {
  //           meta.unreadMails.label[label] ? meta.unreadMails.label[label].push(mail.id) : meta.unreadMails.label[label] = [mail.id]
  //         })
  //       }

  //       // Get draft mail count
  //       if (mail.mailFolder === 'drafts') meta.draftMails.push(mail.id)
  //     })
  //     commit('SET_META', meta)
  //     resolve({ data: meta })
  //   })
  // },

  // Move mails to another folder
  moveMailsTo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const mailsToMove = JSON.parse(payload.data).emailIds

      data.emails.forEach((mail) => {
        if (mailsToMove.includes(mail.id)) mail.mailFolder = JSON.parse(payload.data).mailFolder
      })
      commit('MOVE_MAILS_TO', payload)
      commit('UPDATE_UNREAD_META_ON_MOVE', payload)
      resolve({ data: {} })
    })
  },

  // Update Mails label
  // updateLabels({ commit }, payload) {
  //   const label = JSON.parse(payload.data).label
  //   const mailsToUpdate = JSON.parse(payload.data).emailIds

  //   mailsToUpdate.forEach((mailId) => {
  //     const mailIndex = data.emails.findIndex((mail) => mail.id == mailId)
  //     const labelIndex = data.emails[mailIndex].labels.indexOf(label)

  //     if (labelIndex == -1) {
  //       data.emails[mailIndex].labels.push(label)
  //     } else {
  //       data.emails[mailIndex].labels.splice(labelIndex, 1)
  //     }
  //   })
  //   commit('UPDATE_LABELS', payload)
  //   resolve({ data: {} })
  // },

  // setLabels({ commit }, payload) {
  //   return new Promise((resolve, reject) => {
  //     const mailId = JSON.parse(payload.data).mailId

  //     data.emails.find((mail) => mail.id === mailId).labels = JSON.parse(payload.data).labels
  //     commit('SET_LABELS', payload)
  //     resolve({ data: {} })

  //   })
  // },

  // Set mails flag unread to true
  // setUnread({ commit }, payload) {
  //   return new Promise((resolve, reject) => {
  //     const mailsToUpdate = JSON.parse(payload.data).emailIds

  //     mailsToUpdate.forEach((mailId) => {
  //       const mailIndex = data.emails.findIndex((mail) => mail.id == mailId)
  //       data.emails[mailIndex].unread = JSON.parse(payload.data).unreadFlag
  //     })
  //     commit('SET_UNREAD', payload)

  //     // Remove this if you are getting meta like us
  //     // Use your own method to update email meta if you are fetching email meta
  //     commit('UPDATE_UNREAD_META', payload)
  //     resolve({ data: {} })
  //   })
  // },

  // Toggle isStarred flag in mail
  toggleIsMailStarred({ commit }, payload) {
      commit('TOGGLE_IS_MAIL_STARRED', payload)
  },
  toggleIsMailSelectStarred({ commit }, payload) {
    commit('TOGGLE_IS_MAIL_SELECT_STARRED', payload)
  },
  async getMailFolders({ dispatch, commit }, account) {
    return await emailService.getMailFolders(account)
    .then(response => {
      let foldersName = [];
      Object.values(response.data.data).forEach( (data, index) =>{
        let list = data.folders;
        let folders = []
        list.forEach( str => {
            let strFolder = str.replace('[Gmail]/','');
            // handle String => folder Name
            let arrFolder = strFolder.split('/');
            if(arrFolder[0] === 'INBOX') arrFolder[0] = "Inbox"
            let objFolder = folders.find(folder => folder.name === arrFolder[0]);
            if(!objFolder){
              objFolder = {
                name: arrFolder[0],
                children: []
              }
              folders.push(objFolder);
            }
            if(arrFolder.length > 1){
              arrFolder.shift();
              dispatch('addChildrenFolder',arrFolder , objFolder.children);
            }
        })
        foldersName.push(folders);
      });
        commit('SET_MAIL_FOLDERS', foldersName);
        return Promise.resolve(foldersName);
      })
    .catch(error => {
        dispatch("alertError", error, { root: true });
        return Promise.reject(error);
    })
  },

  async replyMail({dispatch,commit}, mailData){
    return await emailService.replyMail(mailData)
      .then(response => {
        if (response.status  || response.success) {
          if ((response.data && response.data == 'connection SMTP failed') || response.data == false){
            dispatch("alertError", typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
          } else{
            dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
            return Promise.resolve(true);
          }
        } else {
          // dispatch("alertError", typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
          return Promise.reject(typeof response.message == 'object' ? response.message[0]:response.message);
      }
      })
      .catch(error =>{
        dispatch("alertError", error, { root: true });
          return Promise.reject(false);
      })
  }, 
  async createMail({dispatch,commit}, mailData){
    return await emailService.createMail(mailData)
        .then(response => {
            if (response.status  || response.success) {
              if ((response.data && response.data == 'connection SMTP failed') || response.data == false){
                dispatch("alertError", typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
              } else{
                dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
                return Promise.resolve(response.data ? response.data : true);
              }
            } else {
                // dispatch("alertError", typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
                return Promise.reject(typeof response.message == 'object' ? response.message[0]:response.message);
            }
        })
        .catch(error =>{
            dispatch("alertError", error, { root: true });
            return Promise.reject(false);
        })
  },

  addChildrenFolder(arr, arrChild){
    if(!arrChild.some(child => child.name === arr[0])){
      arrChild.push({
        name: arr[0],
        children:[]
      }),
      arrChild.shift();
      if(arr.length > 0) addChildrenFolder(arr, arrChild[arrChild.length-1].children);
    }
    else {
      let obj = arrChild.find(arr => arr.name === arr[0])
      arrChild.shift();
      if (arr.length > 0) addChildrenFolder(arr, obj.children);
    }
  },

  async getMailInFolder({dispatch, commit}, data) {
    const email = data.query.email
    const folder = data.folder
    return await emailService.getMailInFolder(data)
        .then(response => {
          let emailAndFolderSelect = {
            email: email,
            folder: folder
          }
          let result = {
              data: response.data.data,
              folder: folder,
              email: email
          }
          // Todo: delete commit  SET_EMAIL_AND_FOLDER_SELECT after fix bug getMailDetail and ReadMail
          // commit('SET_EMAIL_AND_FOLDER_SELECT', emailAndFolderSelect)
          commit('SET_MAILS', result)
          return Promise.resolve(response.data);
        }).catch(error =>{
          dispatch("alertError", error, { root: true });
          return Promise.reject(false);
        })
  },
  getDetailMail({ dispatch, commit }, data){
    return emailService.getMailDetail(data)
      .then(response => {
        let folder = data.folder
        let email = data.email
        commit('SET_MAIL_SELECTED', response.data, folder, email);
      })
      .catch(error =>{
        dispatch("alertError", error, { root: true });
      })
  },
  getMailSent({ dispatch, commit }, data) {
    return emailService.getMailSent(data)  
        .then(response => {
                return Promise.resolve(response.data);
            },
            error => {
                dispatch("alertError", error, {root: true});
                return Promise.reject(false);
            })
        .catch(error =>{
            dispatch("alertError", error, { root: true });
            return Promise.reject(false);
        })
  },
  async getSelectedMailPreviewMode({ dispatch, commit }, params) {
    return await emailService.getSelectedMailPreviewMode(params)
        .then(response => {
            if (response.success && response.data) {
                const selectedReceiveMail = response.data[0]
                return Promise.resolve(selectedReceiveMail);
            } else {
                return Promise.reject(response.message);
            }
        }).catch(error => {
            if (error.response.status == 410) {
                return Promise.reject(error);
            }
            return Promise.reject(false);
        })
  },

}
